import { useTranslation } from 'react-i18next'

export function LoadingState () {
  const { t } = useTranslation()
  return (
    <div className='w-full h-full min-h-32 flex justify-center items-center border-2 border-dashed rounded-2xl border-gray-200 gap-3 bg-gray-50'>
      <span className="loading loading-ring loading-md" />
      <h2 className="text-gray-500">{t('Loading') + '...'}</h2>
    </div>
  )
}
